import defaultSettings from '@/settings/settings'

const title = defaultSettings.title || 'Broker Hub'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
